// src/utils/gtm.ts
import TagManager from 'react-gtm-module';

export const initializeGTM = () => {
  TagManager.initialize({ gtmId: 'GTM-KPL7ZXZ' });
  console.log('GTM Initialized'); // Verifica si GTM se ha inicializado
};
